module.exports = __webpack_public_path__ + "static/media/pushuser.50e72a01.svg";